import styled from '@emotion/styled'

export const Input = styled.input`
  background: var(--c-bg-elev);
  color: var(--c-fg);
  border: 1px solid var(--c-border);
  border-radius: var(--r-md);
  padding: 10px 12px;
  font-family: var(--font-sans);
  font-size: 14px;
  width: 100%;
  transition: border-color var(--d-fast) var(--ease-standard);

  &::placeholder {
    color: var(--c-fg-subtle);
  }
  &:focus {
    outline: none;
    border-color: var(--c-accent);
    box-shadow: 0 0 0 3px var(--c-accent-soft);
  }
`
